/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Menu Constants
 */

// Generic actions
export const GET_ALL_MENUS = 'Menu/GET_ALL_MENUS';
export const GET_MENU_BY_USER = 'Menu/GET_MENU_BY_USER';
export const GET_MENU_BY_ROLE = 'Menu/GET_MENU_BY_ROLE';
export const GET_MAIN_MENU_BY_ROLE = 'Menu/GET_MAIN_MENU_BY_ROLE';
export const GET_ALL_PERMISSIONS = 'Menu/GET_ALL_PERMISSIONS';
